<template>
  <div id="bus">
    <header>
        <h1>SKYTTELBUSS NON-STOP</h1>
        <h2>Frösundavik<span class="heading-arrow"></span>Solna Station</h2>
        <p>Följ den röda pricken för att se var bussen är någonstans nu.<br>Du kan också se kartan på <span class="link">gate01.se/buss</span>. Trevlig resa!</p>
    </header>
    <alert />
    <GmapMap
      :center="center"
      :zoom="16"
      :options="{
          streetViewControl: false,
          disableDefaultUI: true,
          styles:[
          { elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
          { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
          { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] },
          {
            featureType: 'administrative.locality',
            elementType: 'labels.text.fill',
            stylers: [{ color: '#d59563' }]
          },
          {
            featureType: 'poi.business',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'poi.park',
            elementType: 'geometry',
            stylers: [{ color: '#263c3f' }]
          },
          {
            featureType: 'poi.park',
            elementType: 'labels.text.fill',
            stylers: [{ color: '#6b9a76' }]
          },
          {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [{ color: '#38414e' }]
          },
          {
            featureType: 'road',
            elementType: 'geometry.stroke',
            stylers: [{ color: '#212a37' }]
          },
          {
            featureType: 'road',
            elementType: 'labels.text.fill',
            stylers: [{ color: '#9ca5b3' }]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry',
            stylers: [{ color: '#746855' }]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.stroke',
            stylers: [{ color: '#1f2835' }]
          },
          {
            featureType: 'road.highway',
            elementType: 'labels.text.fill',
            stylers: [{ color: '#f3d19c' }]
          },
          {
            featureType: 'transit',
            elementType: 'geometry',
            stylers: [{ color: '#2f3948' }]
          },
          {
            featureType: 'transit.station',
            elementType: 'labels.text.fill',
            stylers: [{ color: '#d59563' }]
          },
          {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [{ color: '#17263c' }]
          },
          {
            featureType: 'water',
            elementType: 'labels.text.fill',
            stylers: [{ color: '#515c6d' }]
          },
          {
            featureType: 'water',
            elementType: 'labels.text.stroke',
            stylers: [{ color: '#17263c' }]
          }
        ]
      }"
      ref="mapRef"
    >
      <gmap-marker :position="marker.position" :icon="marker.icon"></gmap-marker>
    </GmapMap>
    <footer>
      <div class="inner">
        <div class="logo">
          <img src="./assets/Frosundavik_logo_vit.svg" style="width: 400px;" />
        </div>
        <!--
        <p>Onsdagen den 29 maj (dagen före Kristi Himmelfärdsdag) kommer skyttelbussen att gå eftermiddagen mellan 12:00 och 15:00 istället för ordinarie tidtabell. På morgonen går bussen som vanligt.</p>
        <p>On Wednesday May 29th (the day before Ascension Day), the shuttle bus will run between 12 pm and 3 pm instead of the regular afternoon schedule. The morning schedule runs as usual.</p>
        -->
      </div>
    </footer>
  </div>
</template>

<script>
import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import axios from 'axios'
import Alert from './components/Bus/Alert.vue'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBfGO5kM0J6M0N7N5wtRe_GSqpYuDd8KhU'
  }
})

export default {
  data () {
    return {
      pollingRate: 1000,
      // center: { lat: 59.3685941, lng: 18.017118 },
      center: { lat: 59.368751, lng: 18.014318 },
      lat: 0,
      lng: 0,
      markers: [],
      marker: {},
      interval: null,
      cachedData: []
    }
  },
  beforeDestroy () {
    clearInterval(this.interval)
    this.interval = null
  },
  mounted () {
    this.loadData()
    this.interval = setInterval(() => {
      this.loadData()
    }, this.pollingRate)
    // At this point, the child GmapMap has been mounted, but
    // its map has not been initialized.
    // Therefore we need to write mapRef.$mapPromise.then(() => ...)
    this.$refs.mapRef.$mapPromise.then((map) => {
      this.marker = {
        position: {
          lat: this.lat,
          lng: this.lng
        },
        icon: {
          url: require('./assets/bus-larger.png'),
          size: this.google && this.google.maps && new this.google.maps.Size(70, 70),
          origin: this.google && this.google.maps && new this.google.maps.Point(0, 0),
          anchor: this.google && this.google.maps && new this.google.maps.Point(35, 35)
        }
      }

      var mainBuildingCoords = [
        { lat: 59.370595433618746, lng: 18.023882321415726 },
        { lat: 59.370567419534524, lng: 18.02413176685411 },
        { lat: 59.371425851177506, lng: 18.02405437098082 },
        { lat: 59.37144429901266, lng: 18.02444329128798 },
        { lat: 59.37130013233018, lng: 18.02473296986159 },
        { lat: 59.37133429510653, lng: 18.024901949029527 },
        { lat: 59.37157070057615, lng: 18.02443792686995 },
        { lat: 59.371518090252884, lng: 18.024309180837236 },
        { lat: 59.37164244179454, lng: 18.024069123130403 },
        { lat: 59.37184448696812, lng: 18.02406509981688 },
        { lat: 59.37184038749845, lng: 18.024319909673295 },
        { lat: 59.37190119624801, lng: 18.024299793105683 },
        { lat: 59.371893680565776, lng: 18.024696760039888 },
        { lat: 59.37199685024026, lng: 18.024652503591142 },
        { lat: 59.37200641562465, lng: 18.023921601634584 },
        { lat: 59.37206380787433, lng: 18.02393903599318 },
        { lat: 59.37206380787433, lng: 18.024276994329057 },
        { lat: 59.372248282304994, lng: 18.024584107261262 },
        { lat: 59.37227082911105, lng: 18.02432795630034 },
        { lat: 59.37217585912962, lng: 18.02417104707297 },
        { lat: 59.37239273865328, lng: 18.024030231099687 },
        { lat: 59.37262214987815, lng: 18.024258218865953 },
        { lat: 59.37269593855626, lng: 18.02418043480452 },
        { lat: 59.3729558496145, lng: 18.02349456998286 },
        { lat: 59.37278026097165, lng: 18.02347311231074 },
        { lat: 59.37267641045167, lng: 18.023796318497034 },
        { lat: 59.37246241111899, lng: 18.023756143877904 },
        { lat: 59.37243508180955, lng: 18.023651537726323 },
        { lat: 59.37251706967188, lng: 18.023530838320653 },
        { lat: 59.372507504431475, lng: 18.023372587988774 },
        { lat: 59.372254024578204, lng: 18.023451713154714 },
        { lat: 59.37226768930864, lng: 18.023277369568746 },
        { lat: 59.372085947943816, lng: 18.023284075091283 },
        { lat: 59.372027872490364, lng: 18.023482558558385 },
        { lat: 59.37187084585235, lng: 18.023456609609866 },
        { lat: 59.37188177776061, lng: 18.023185706499362 },
        { lat: 59.37204165651639, lng: 18.022906756761813 },
        { lat: 59.37190159183535, lng: 18.02287725246265 },
        { lat: 59.37172873072438, lng: 18.02321252858951 },
        { lat: 59.3716659365231, lng: 18.023087088991133 },
        { lat: 59.37180805191413, lng: 18.022769247222868 },
        { lat: 59.37173426130466, lng: 18.022629772354094 },
        { lat: 59.37151562151932, lng: 18.023092453409163 },
        { lat: 59.37155593333569, lng: 18.02319840066525 },
        { lat: 59.37142013453951, lng: 18.023458244460585 },
        { lat: 59.371241121662194, lng: 18.02336704935408 },
        { lat: 59.37115441930604, lng: 18.02317164844351 },
        { lat: 59.37106354576311, lng: 18.023399636209774 },
        { lat: 59.37096515608882, lng: 18.02316091960745 },
        { lat: 59.37091663386829, lng: 18.02328729064891 },
        { lat: 59.371077883693545, lng: 18.023689622001143 },
        { lat: 59.37098769320778, lng: 18.02386933000514 },
        { lat: 59.37059240253672, lng: 18.023884794330343 }
      ]

      var sideBuildingCoords = [
        { lat: 59.37106448519795, lng: 18.02259432159326 },
        { lat: 59.371244182264356, lng: 18.022992629631972 },
        { lat: 59.37152650993024, lng: 18.02246331681806 },
        { lat: 59.37157570398903, lng: 18.022534395356956 },
        { lat: 59.37171167053039, lng: 18.02224874009687 },
        { lat: 59.37190493150393, lng: 18.022249458513784 },
        { lat: 59.37172250494823, lng: 18.021776048622655 },
        { lat: 59.37127544881975, lng: 18.02260394813777 },
        { lat: 59.37106445694989, lng: 18.02259337303269 }
      ]

      var mainBuilingPath = new this.google.maps.Polyline({
        path: mainBuildingCoords,
        geodesic: true,
        strokeColor: '#ffffff',
        strokeOpacity: 0.1,
        strokeWeight: 2
      })

      var sideBuilingPath = new this.google.maps.Polyline({
        path: sideBuildingCoords,
        geodesic: true,
        strokeColor: '#ffffff',
        strokeOpacity: 0.1,
        strokeWeight: 2
      })

      mainBuilingPath.setMap(map)
      sideBuilingPath.setMap(map)

      /* this.google.maps.event.addListener(map, 'click', function (event) {
        var latitude = event.latLng.lat()
        var longitude = event.latLng.lng()
        console.log(`{ lat: ${latitude}, lng: ${longitude} },`)
      }) */
    })
  },
  methods: {
    loadData () {
      axios.get(`https://gate01.se/api/positioning/read.php`)
        .then(response => {
          if (response && response.data) {
            this.cachedData = response.data
            this.lat = +this.cachedData.y
            this.lng = +this.cachedData.x
            this.marker.position = {
              lat: +this.cachedData.y,
              lng: +this.cachedData.x
            }
          }
        }).catch(() => {
        })
    }
  },
  computed: {
    google: VueGoogleMaps.gmapApi
  },
  components: {
    Alert
  }
}
</script>

<style lang="scss">
  @import 'style/app.scss';
  #bus {
    header {
      background: black;
      position: absolute;
      text-align: center;
      width: 100%;
      z-index: 1000;
      padding: 6rem 0;

      h1 {
        font-size: 3.5rem;
        color: #ebb836;
        font-weight: 400;
        letter-spacing: 2px;
      }

      h2 {
        font-size: 5.5rem;
        font-family: 'Paytone One';
        font-weight: 400;
        letter-spacing: 2px;
        line-height: 3rem;
        margin: 2rem 0 3rem 0;
      }

      p {
        font-size: 2.6rem;
      }

      .link {
        color: #ebb836;
      }

      .heading-arrow {
        background: url('./assets/heading-arrows.png') no-repeat;
        display: inline-block;
        margin: 0 20px;
        width: 66px;
        height: 31px;
      }
    }

    footer {
      background: black;
      min-height: 250px;
      bottom: 0;
      width: 100%;
      position: absolute;

      .inner {
        padding: 4rem;
      }

      .logo {
        text-align: center;
        margin: 5rem 0 7rem;
      }

      p {
        font-size: 2.6rem;
        line-height: 4rem;
        + p {
          margin-top: 5rem;
        }
      }
    }

    background: white;
    color: white;
    padding: 0;
    width: 100%;
    height: 100%;
    font-size: 1;
    overflow: hidden;
    position: absolute;
    @media (min-width: 1050px) {
      width: 1080px;
      height: 1920px;
    }
    .vue-map-container {
      width: 100%;
      height: calc(100% - 250px);
      background: #000;
    }
  }
</style>
